package com.example.mystybag.sharedmodels.common.requestModels

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_PUSH_TOKEN
import kotlinx.serialization.Serializable
import com.example.mystybag.sharedmodels.base.BaseRequestModel

@Serializable
class UpdatePushTokenRequestModel(
    val token                   : String = ""
): BaseRequestModel(api = UPDATE_PUSH_TOKEN)